var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.32216 0.764365C1.84286 0.243666 2.68708 0.243666 3.20778 0.764365L10.265 7.82156L17.3222 0.764365C17.8429 0.243666 18.6871 0.243666 19.2078 0.764365C19.7285 1.28506 19.7285 2.12928 19.2078 2.64998L12.1506 9.70717L19.2078 16.7644C19.7285 17.2851 19.7285 18.1293 19.2078 18.65C18.6871 19.1707 17.8429 19.1707 17.3222 18.65L10.265 11.5928L3.20778 18.65C2.68708 19.1707 1.84286 19.1707 1.32216 18.65C0.801466 18.1293 0.801466 17.2851 1.32216 16.7644L8.37936 9.70717L1.32216 2.64998C0.801466 2.12928 0.801466 1.28506 1.32216 0.764365Z",
    fill: "#bbb9b9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.25c3df0245ce9f314c7096663153d82b.svg";
export { ForwardRef as ReactComponent };